import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

const authorizedAxios = axios.create();

authorizedAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error;
    if (res?.response?.status === 401 || res?.response?.status === 423) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = `user/login`;
    }

    console.error(
      `Looks like there was a problem. Status Code: ` + res?.response?.status
    );
    return error;
  }
);

export const postCall = async (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseURL + url, data)
      .then((data) => {
        resolve({
          ...data.data,
          ...(data.headers.refresh_token && {
            refresh_token: data.headers.refresh_token,
          }),
          ...(data.headers.token && {
            token: data.headers.token,
          }),
        });
      })
      .catch((err) => reject(err));
  });
};

export const getCall = async (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseURL + url)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => reject(err));
  });
};

export const authorizedPostCall = async (url, data) => {
  return new Promise((resolve, reject) => {
    authorizedAxios
      .post(baseURL + url, data, {
        headers: {
          token: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((data) => {
        if (data?.status >= 200 && data?.status <= 299) resolve(data.data);
        else reject(data);
      })
      .catch((err) => reject(err));
  });
};

export const authorizedPutCall = async (url, data) => {
  return new Promise((resolve, reject) => {
    authorizedAxios
      .put(baseURL + url, data, {
        headers: {
          token: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => reject(err));
  });
};

export const authorizedDeleteCall = async (url) => {
  return new Promise((resolve, reject) => {
    authorizedAxios
      .delete(baseURL + url, {
        headers: {
          token: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => reject(err));
  });
};

export const authorizedGetCall = async (url) => {
  return new Promise((resolve, reject) => {
    authorizedAxios
      .get(baseURL + url, {
        headers: {
          token: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => reject(err));
  });
};
